import { useEffect, useState } from "react";
import Table, { Column } from "../../../Components/Tables/Table";
import PageHeader from "../../../Layout/PageHeader";
import historyIcon from "../../../assets/images/history-icon.svg";
import { useNavigate, useParams } from "react-router-dom";
import DynamicDetailGrid from "../../../Components/Grid/DynamicDetailGrid";
import { HistoryLaoutDataCheckInDetail } from "../../../Data/testData";
import HistoryLayout from "../../../Layout/HistoryLaout";
import { readyToPickDetailData } from "../../../Data/outbound";
import AssignToUserLayout from "../../../Layout/AssignToUserLayout";
import warningIcon from "../../../assets/images/warning.svg";
import CommonModal from "../../../Components/Modals/CommonModal";
import PickedLayout from "../../../Layout/PickedLayout";
import { getPickDetails } from "./service/pickOverview.service";
import Loader from "../../../Components/GlobalLoader/Loader";
import { PickShipmentLine, PickTicket } from "./model/pick.model";
import { formatDate, formatNumber } from "../../../Utility/Utility";

export default function PickDetails() {
  const { id } = useParams<{ id: string }>();
  const [show, setShow] = useState(false);
  // const handleShow = () => setShow(!show);
  const [isShowCanvas, setShowCanvas] = useState(false);
  const [loading, setLoading] = useState(true);
  const [pickTickets, setPickTickets] = useState<PickTicket | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [shipmentLine, setShipmentLine] = useState<any>(null);
  const navigation = useNavigate();
  const pageName = `Pick (${pickTickets?.pick_number ?? "-"})`;

  useEffect(() => {
    if (id) {
      fetchPickDetails();
    } else {
      setError('No pick ID provided');
      setLoading(false);
    }
  }, [id]);

  const fetchPickDetails = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await getPickDetails(id!);
      setPickTickets(response.data);
      setShipmentLine(response.data.picks_by_shipment);
    } catch (error) {
      console.error("Error fetching pick details:", error);
      setError(error instanceof Error ? error.message : 'Failed to fetch pick details');
    } finally {
      setLoading(false);
    }
  };
  console.log('pickTickets', pickTickets);
  console.log('shipmentLine', shipmentLine);

  const handelCanvas = () => {
    setShowCanvas(!isShowCanvas);
  };
  const [showRecountModal, setShowRecountModal] = useState(false);

  const handleWarningClick = () => {
    setShowRecountModal(true);
  };
  const handleRowClick = (data: any) => {
    return navigation(`/outbound/shipments/details/${data}`);
  };

  const closeRecountModal = () => {
    setShowRecountModal(false);
  };
  const historyData = (
    <>
      <div
        key="history-header"
        className="d-flex justify-content-between w-100 align-items-center px-4"
        onClick={handelCanvas}
      >
        <div>
          <h6 className="cursor-pointer m-0 d-flex align-items-center">
            <img src={historyIcon} className="me-2" />
            History
          </h6>
        </div>
      </div>
    </>
  );
  const readyToPickDetails = [
    { label: "Total Quantity", value: pickTickets?.total_qty ?? "-" },
    { label: "Created On", value: (<>{formatDate(pickTickets?.created_at ?? "-")}</>) },
    { label: "Pick Method", value: pickTickets?.pick_method_lookup.description ?? "-" },
    { label: "Assigned To", value: pickTickets?.assigned_to_user?.name ?? "-" },
    { label: "Assigned Warehouse", value: pickTickets?.warehouse?.name ?? "-" },
    { label: "Pick Area", value: pickTickets?.warehouse_area ?? "-" },
    { label: "Drop Location", value: pickTickets?.drop_warehouse_location?.name ?? "-" },
    {
      label: "Status",
      value: (
        <>
          {pickTickets?.status === "ready to pick" ? (
            <span className="badge asn-overview-status asn-overview-status-border-blue rounded px-4 fs-11 w-auto d-inline-block">
              Ready to Pick
            </span>
          ) : pickTickets?.status === "partially picked" ? (
            <span className="badge asn-overview-status asn-overview-status-border-blue rounded px-4 fs-11 w-auto d-inline-block">
              Partially Picked
            </span>
          ) :
            pickTickets?.status === "pick complete" ? (
              <span className="badge asn-overview-status asn-overview-status-border-blue rounded px-4 fs-11 w-auto d-inline-block">
                Pick Complete
              </span>
            ) : (
              <span className="badge asn-overview-status asn-overview-status-border-blue rounded px-4 fs-11 w-auto d-inline-block">
                {pickTickets?.status ?? '-'}
              </span>
            )
          }
        </>
      )
    },
    {
      label: "Picked Quantity", value: (
        <>{formatNumber(pickTickets?.picked_qty ?? "-")}</>
      )
    },
  ];
  const columns: Column[] = [
    {
      name: "Shipment Line",
      selector: (row: PickShipmentLine) => row.shipment_line_id,
    },
    {
      name: "Location",
      selector: (row: PickShipmentLine) => row.warehouse_location_name,
    },
    {
      name: "Item Code",
      selector: (row: PickShipmentLine) => row.item_code,
    },
    {
      name: "Item Name",
      selector: (row: PickShipmentLine) => (
        <span
          title={
            row.item_name && row.item_name.length > 15
              ? row.item_name
              : ""
          }
        >
          {row.item_name && row.item_name.length > 15
            ? `${row.item_name.slice(0, 15)}...`
            : row.item_name}
        </span>
      ),
    },
    {
      name: "UOM",
      selector: (row: PickShipmentLine) => row.uom_code,
    },
    {
      name: "Shipment #",
      selector: (row: PickShipmentLine) => {
        return (
          <div
            className="text-primary cursor-pointer"
            onClick={() => handleRowClick(row.shipment_id)}
          >
            {row.shipment_number}
          </div>
        );
      },
    },
    {
      name: "Qty To Pick",
      selector: (row: PickShipmentLine) => {
        return <>{formatNumber(row.requested_pick_qty) ?? 0}</>;
      },
    },
    {
      name: "Picked Qty",
      selector: (row: PickShipmentLine) => {
        return (
          <>
            {formatNumber(row.picked_qty) ?? 0}
            {/* {row.is_skip === 1 && (
              <img
                src={warningIcon}
                alt="Recounted"
                style={{
                  width: "18px",
                  marginRight: "8px",
                  marginLeft: "20px",
                }}
                onClick={handleWarningClick}
                className="cursor-pointer"
              />
            )} */}
          </>
        );
      },
    },
  ];

  const handelAssignAction = () => {
    setShow(true);
  };
  if (loading) {
    return <Loader />;
  }
  return (
    <>
      <PageHeader
        listUrl="/outbound/pick/overview"
        viewType={true}
        isHistoryEnabled={true}
        historyData={[historyData]}
        isModal={true}
        name="ASSIGN"
        heading="Assign To"
        content={<AssignToUserLayout handleClose={() => setShow(false)} />}
        modalSize="modal-md"
        customBtn={handelAssignAction}
        isCustomBtn={true}
      />


      <h5 className="text-start mt-1 mb-3">{pageName}</h5>
      <div className="my-2 bg-white rounded py-1 d-flex flex-column">
        <div className="shipments-details col-12 bg-white col-12 py-1">
          <div className="shipments-details flex-column-reverse align-items-center d-flex bg-white ">
            <div className="d-flex col-12 py-4">
              <div className="d-flex col">
                <DynamicDetailGrid
                  customClassName="mb-2 pt-0 col"
                  isExpandable={false}
                  columns={3}
                  data={readyToPickDetails}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="my-2 bg-white rounded py-1 px-2 vertical-scrollable-table">
        <Table
          columns={columns}
          data={shipmentLine ?? []}
          CheckboxStatus={false}
          enableScrollbar={true}
          isStripped={true}
          customClassName="transferDetailsTable"
        />
      </div>
      <HistoryLayout
        isShowCanvas={isShowCanvas}
        showViewScanLogs={true}
        handelCanvas={handelCanvas}
        data={HistoryLaoutDataCheckInDetail}
      />
      <CommonModal
        handleClose={closeRecountModal}
        show={showRecountModal}
        content={<PickedLayout handleClose={closeRecountModal} />}
        modalSize="modal-md"
      />
      <CommonModal
        handleClose={() => setShow(false)}
        show={show}
        heading="Assign To"
        content={<AssignToUserLayout handleClose={() => setShow(false)} />}
        modalSize="modal-lg"
        footerButtonsActive={false}
      />

    </>
  );
}
